import { EnvironmentProviders, isDevMode } from '@angular/core';
import { provideState, provideStore } from '@ngrx/store';
import { accountFeature } from './account/account.state';
import { provideStoreDevtools, StoreDevtoolsOptions } from '@ngrx/store-devtools';
import { provideEffects } from '@ngrx/effects';
import accountEffect from './account/account.effect';

const storeDevToolsConfig: StoreDevtoolsOptions = {
  maxAge: 25,
  logOnly: !isDevMode(),
  autoPause: true,
  trace: false,
  traceLimit: 75,
  connectInZone: true,
};

export const storeProviders: EnvironmentProviders[] = [
  provideStoreDevtools(storeDevToolsConfig),
  provideStore(),
  provideState(accountFeature),
  provideEffects(accountEffect),
];
